import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { useParams } from 'react-router';
import { API } from 'aws-amplify';

import { buttonsReset } from 'src/store/modules/buttons';
import { customlogReset } from 'src/store/modules/customlog';
import { editTextReset } from 'src/store/modules/editText';
import { imageReset } from 'src/store/modules/imageUpload';
import { pagesReset } from 'src/store/modules/pages';
import { editTemplateId, templateReset } from 'src/store/modules/template';
import setInitValue from 'src/utils/setInitValue';

import {
  initViewValues,
  initTrackingValues,
  ViewTemplates
} from './initValues';

const ShortAnswerSurveyView = () => {
  const dispatch = useDispatch();

  const currentBranchIndex = useSelector(
    (state: any) => state.imageUpload.currentBranchIndex
  );

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
          dispatch(editTemplateId(id));
        }
      } catch (err) {}
    }
    onLoad();
    setInitValue(dispatch, {
      ...initViewValues,
      ...initTrackingValues
    });
    return () => {
      dispatch(buttonsReset());

      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());

      dispatch(customlogReset());
    };
  }, []);

  return ViewTemplates[currentBranchIndex];
};
export default ShortAnswerSurveyView;
